import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { GlpProgramAnnouncementInfo } from '@web-app/components/tagActions/GlpProgramAnnouncementInfo';
import React, { useEffect } from 'react';

const GLP1TemplateUsageReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Auto-open the modal when component mounts
  useEffect(() => {
    onOpen();
  }, [onOpen]);

  const handleCompleted = () => {
    onClose();
  };

  return (
    <SessionReminderModal
      popupId="glp1-reminder"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent bg="bg.default" color="text.default">
        <ModalHeader>⚠️ GLP-1 Patient Flag</ModalHeader>

        <ModalBody>
          <VStack spacing={4} align="start">
            <Text>
              This patient has indicated they are currently on or interested in
              GLP-1 medication.
            </Text>
            <Text>
              We recommend selecting the &quot;GLP-1&quot; template to guide
              your session.
            </Text>
            <GlpProgramAnnouncementInfo />
          </VStack>
        </ModalBody>

        <ModalFooter>
          <VStack spacing={2} w="full">
            <Button colorScheme="blue" onClick={handleCompleted} w="full">
              Got it!
            </Button>
          </VStack>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default GLP1TemplateUsageReminderModal;
